export var CLASS_ANNOUNCEMENT_REPOSITORY = 'CLASS_ANNOUNCEMENT_REPOSITORY';